import { ApolloQueryResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface StoreConfig {
  storeConfig: {
    absolute_footer: boolean
    base_currency_code: boolean
    base_link_url: boolean
    base_media_url: boolean
    base_static_url: boolean
    base_url: boolean
    catalog_default_sort_by: boolean
    category_url_suffix: boolean
    cms_home_page: boolean
    cms_no_cookies: boolean
    cms_no_route: boolean
    code: boolean
    copyright: boolean
    country_options: {
      optional_zip_countries: boolean
    }
    create_account_confirmation: boolean
    default_description: boolean
    default_display_currency_code: boolean
    default_keywords: boolean
    default_title: boolean
    demonotice: boolean
    front: boolean
    head_includes: boolean
    head_shortcut_icon: boolean
    header_logo_src: boolean
    id: boolean
    locale: boolean
    logo_alt: boolean
    logo_height: boolean
    logo_width: boolean
    no_route: boolean
    pwa_url: boolean
    product_url_suffix: boolean
    region_options: {
      state_required: boolean
    }
    secure_base_link_url: boolean
    secure_base_media_url: boolean
    secure_base_static_url: boolean
    secure_base_url: boolean
    show_cms_breadcrumbs: boolean
    timezone: boolean
    title_prefix: boolean
    title_suffix: boolean
    website_id: boolean
    weight_unit: boolean
    welcome: boolean
    grid_per_page: boolean
    grid_per_page_values: boolean
  }
}

export const storeConfig: StoreConfig = {
  storeConfig: {
    absolute_footer: true,
    base_currency_code: true,
    base_link_url: true,
    base_media_url: true,
    base_static_url: true,
    base_url: true,
    catalog_default_sort_by: true,
    category_url_suffix: true,
    cms_home_page: true,
    cms_no_cookies: true,
    cms_no_route: true,
    code: true,
    copyright: true,
    country_options: {
      optional_zip_countries: true
    },
    create_account_confirmation: !process.env.REACT_APP_DISABLE_CREATE_ACCOUNT_CONFIRMATION,
    default_description: true,
    default_display_currency_code: true,
    default_keywords: true,
    default_title: true,
    demonotice: true,
    front: true,
    head_includes: true,
    head_shortcut_icon: true,
    header_logo_src: true,
    id: true,
    locale: true,
    logo_alt: true,
    logo_height: true,
    logo_width: true,
    no_route: true,
    pwa_url: !process.env.REACT_APP_DISABLE_STORE_CONFIG_PWA_URL,
    product_url_suffix: true,
    region_options: {
      state_required: true
    },
    secure_base_link_url: true,
    secure_base_media_url: true,
    secure_base_static_url: true,
    secure_base_url: true,
    show_cms_breadcrumbs: true,
    timezone: true,
    title_prefix: true,
    title_suffix: true,
    website_id: true,
    weight_unit: true,
    welcome: true,
    grid_per_page: true,
    grid_per_page_values: true
  }
}

export type StoreConfigQuery = () => Promise<ApolloQueryResult<any>>

export const createStoreConfigQuery = ({ getQueries }: ServiceDependencies): StoreConfigQuery => async () => {
  const query = getQueries().storeConfig

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`,
    context: {
      fetchOptions: {
        method: 'GET'
      }
    }
  })
}
